import { render, staticRenderFns } from "./EmployeeManagement.vue?vue&type=template&id=b620a890&scoped=true&"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js&"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeManagement.vue?vue&type=style&index=0&id=b620a890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620a890",
  null
  
)

export default component.exports